module.exports = __webpack_public_path__ + "img/cloud-computing.fe4b61ac.png";